import utils from '../../../utils';

export default [
  {
    width: 16,
    header: {
      type: 'text',
      caption: 'Date',
      sort: 'dateCreated',
    },
    cell: {
      type: 'slot',
      name: 'date',
    },
  },
  {
    width: 8,
    header: {
      type: 'text',
      caption: 'Trade id',
    },
    cell: {
      type: 'text',
      value: (e) => e.id,
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Market',
    },
    cell: {
      type: 'text',
      value: (e) => utils.getMarketById(e.marketId).name,
    },
  },
  {
    width: 15,
    header: {
      type: 'text',
      caption: 'Taker',
    },
    cell: {
      type: 'slot',
      name: 'taker',
    },
  },
  {
    width: 15,
    header: {
      type: 'text',
      caption: 'Maker',
    },
    cell: {
      type: 'slot',
      name: 'maker',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Price',
      sort: 'price',
    },
    cell: {
      type: 'slot',
      name: 'price',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Amount',
      sort: 'amount',
    },
    cell: {
      type: 'slot',
      name: 'amount',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Summ',
    },
    cell: {
      type: 'text',
      value: (e) => e.price * e.amount,
    },
  },
];
